/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Image,
  useBreakpointValue,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import {
  RemarketMobileDrawer,
  RemarketStorieModal,
} from '@ieo/Components/Modal/RemarketModal';

/* Configs */
import { StoriesSt } from '@ieo/Common/CompLangConfig';
import { useIsMobile } from '@ieo/hooks/useIsMobile';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} lang
 * @returns {ReactElement} Stories
 */

const RemarketStories = ({
  sectionContent,
  region,
  lang,
  pageData,
  prgData,
}) => {
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );
  // const storiRef = useRef(null);
  const [modalData, setModalData] = useState(null);
  const { isMobile, isOpen, onOpen, onClose } = useIsMobile();

  const [activeSlide, setActiveSlide] = useState(0);
  const numberVariant = useBreakpointValue({
    base: 1,
    md: 2,
    lg: 3,
  });

  const NextArrow = props => {
    const { onClick } = props;

    return (
      <Box
        bgColor={
          Math.ceil(activeSlide + numberVariant) ===
          sectionContent?.[0]?.testimonials?.length
            ? '#ffffff'
            : '#F37021'
        }
        onClick={onClick}
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
        pos={{ base: 'sticky', md: 'absolute' }}
        top={{ base: '100%', md: '-90px', lg: '-102px' }}
        mt={{ base: '30px', md: '0px' }}
        right={{
          base: '20%',
          sm: '30%',
          md: '40px',
          xl: '-70px',
          '2xl': '-50px',
        }}
        left={{ base: '55%', md: 'auto' }}
        zIndex="99"
        w={{ base: '44px', md: '64px' }}
        h={{ base: '44px', md: '64px' }}
        _hover={{
          boxShadow: '0 4px 10px -5px #6D6358',
          bgColor:
            Math.ceil(activeSlide + numberVariant) ===
            sectionContent?.[0]?.testimonials?.length
              ? '#ffffff'
              : '#BC570F',
        }}
      >
        <svg
          width="10"
          height="14"
          viewBox="0 0 10 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.83337 11.3333L7.16671 6.99996L2.83337 2.66663"
            stroke={
              Math.ceil(activeSlide + numberVariant) ===
              sectionContent?.[0]?.testimonials?.length
                ? '#F37021'
                : '#ffffff'
            }
            strokeWidth="3"
            strokeLinecap="square"
          />
        </svg>
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        cursor="pointer"
        bgColor={
          Math.ceil(activeSlide + numberVariant) ===
          sectionContent?.[0]?.testimonials?.length
            ? '#F37021'
            : '#ffffff'
        }
        onClick={onClick}
        display="flex"
        alignItems="center"
        justifyContent="center"
        pos={{ base: 'sticky', md: 'absolute' }}
        top={{ base: '100%', md: '-90px', lg: '-102px', xl: '-102px' }}
        right={{ base: '0px', md: '174px', xl: '175px' }}
        left={{
          base: '30%',
          sm: '35%',
          md: '75.5%',
          lg: '81.4%',
          xl: '93%',
          '2xl': '91%',
        }}
        zIndex="99"
        w={{ base: '44px', md: '64px' }}
        h={{ base: '44px', md: '64px' }}
        _hover={{
          boxShadow: '0 4px 10px -5px #6D6358',
          bgColor:
            Math.ceil(activeSlide + numberVariant) ===
            sectionContent?.[0]?.testimonials?.length
              ? '#BC570F'
              : '#ffffff',
        }}
      >
        <svg
          width="10"
          height="14"
          viewBox="0 0 10 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.16663 11.6678L2.83329 7.33443L7.16663 3.0011"
            stroke={
              Math.ceil(activeSlide + numberVariant) ===
              sectionContent?.[0]?.testimonials?.length
                ? '#ffffff'
                : '#F37021'
            }
            strokeWidth="3"
            strokeLinecap="square"
          />
        </svg>
      </Box>
    );
  };

  const settings = {
    arrow: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    lazyLoad: false,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2.5,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      bg={{
        base:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.stories?.bgImage?.mob}) repeat-x #F1EBDF`
            : `#F1EBDF`,
        sm:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.stories?.bgImage?.tab}) repeat-x #F1EBDF`
            : `#F1EBDF`,
        md:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.stories?.bgImage?.desktop}) repeat-x #F1EBDF`
            : `#F1EBDF`,
        lg:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.stories?.bgImage?.bigScreen}) repeat-x #F1EBDF`
            : `#F1EBDF`,
      }}
      bgPos="top"
      mt={'-100px'}
      pt={{ base: '0px', md: '80px' }}
    >
      <Flex
        maxW="1030px"
        flexDir="column"
        py={{ base: '40px', md: '60px', xl: '100px' }}
        alignItems="center"
        w="full"
        justify="center"
        margin={'0 auto'}
      >
        <Box maxW={1130} w="full" pos="relative" pt={{ md: '30px', xl: '0px' }}>
          {/* Heading */}
          <Flex
            justifyContent="space-between"
            w={{
              base: 'full',
              md: '87.5%',
              lg: '79.6%',
              xl: '91%',
              '2xl': '88%',
            }}
            alignItems={{
              md: lang === 'ar' ? 'flex-start' : 'baseline',
              lg: 'center',
            }}
            minH={{ base: '10px', md: '100px', lg: '150px' }}
          >
            <Flex
              flexDir="column"
              w="full"
              px="16px"
              align={{ base: 'center', md: 'flex-start' }}
            >
              <Heading
                as="h2"
                color="#E86F34"
                pr={{ md: '14%', xl: lang == 'ar' ? '40%' : '2%' }}
                {...StoriesSt[lang].subTitle}
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
                textAlign={lang == 'ar' ? 'right' : 'left'}
              >
                {sectionContent?.[0]?.title[0]?.titleSubtext}
                <Box
                  as="span"
                  display="block"
                  color="#12166F"
                  textAlign={lang == 'ar' ? 'right' : 'left'}
                  fontSize={{ base: '26px', md: '52px' }}
                  lineHeight={{ base: '33.8px', md: '67.6px' }}
                  fontFamily="FedraSansStd-medium"
                >
                  {sectionContent?.[0]?.title[0]?.titleText}
                </Box>
              </Heading>
            </Flex>
          </Flex>

          <Slider {...settings}>
            {sectionContent?.[0]?.testimonials?.map((item, index) => {
              let testimonialTitle = JSON?.parse(
                JSON.stringify(item?.testimonialTitle)
              );
              delete testimonialTitle?.value?.document?.children?.[0]
                ?.children[1];

              const stripHTMLTags = text => text.replace(/<[^>]*>/g, ''); // Regular expression to remove tags

              // Function to truncate text and add ellipsis
              const truncateText = (text, maxLength = 74) => {
                if (text.length > maxLength) {
                  return text.slice(0, maxLength) + '...';
                }
                return text;
              };

              // Strip HTML tags and then truncate text
              const renderText = truncateText(
                stripHTMLTags(render(item.testimonialText))
              );
              return (
                <Box
                  width={{ base: '100% !important', md: '350px !important' }}
                  key={index}
                  pt={{ base: '0px', md: '10px' }}
                  px={{ base: '16px' }}
                >
                  <Box position="relative" display="flex" gridGap="30px">
                    <Box overflow="hidden" boxShadow="lg" bg="#fff">
                      {item.photo.url && (
                        <Image
                          src={item.photo.url}
                          alt="Profile picture of a person standing outdoors"
                          objectFit="cover"
                          w="full"
                          h="282px"
                        />
                      )}
                      <Box p={{ base: '1.125rem 1.375rem 1.375rem' }}>
                        <Box
                          display="flex"
                          flexDir="column"
                          alignItems="center"
                          mb={{ base: '1.125rem' }}
                          fontFamily="FedraSansStd-medium"
                        >
                          <StructuredTextParser
                            mt="0px"
                            pr="5px"
                            maxWidth="auto"
                            str={render(item?.userDescription)}
                            color="#6D6358"
                            fontSize="1.5rem"
                            lineHeight="2.25rem"
                          />
                          <StructuredTextParser
                            mt="0px"
                            pr="5px"
                            maxWidth="auto"
                            textAlign="center"
                            str={render(item?.additionalDetails)}
                            color="#12166F"
                            fontSize={{ base: '1rem', md: '1.125rem' }}
                            lineHeight="1.418rem"
                            fontFamily="FedraSansStd-book"
                            fontWeight={450}
                          />
                          {/* <Text
                            fontSize={{ base: '1.125rem', md: '1.375rem' }}
                            lineHeight={{ base: '1.688rem', md: '2.063rem' }}
                            color="#6D6358"
                          >
                            {item?.userName}
                          </Text> */}
                          {/* <StructuredTextParser
                            mt="0px"
                            pr="5px"
                            maxWidth="auto"
                            str={render(item.userDescription)}
                            color="#12166F"
                            fontSize="1rem"
                            lineHeight="1.688rem"
                          /> */}
                        </Box>

                        <Box
                          fontFamily="FedraSansStd-book"
                          id="wrap_p_text"
                          position={!isMobile && 'relative'}
                        >
                          {isMobile ? (
                            <StructuredTextParser
                              fontSize={{ base: '1rem', md: '1.125rem' }}
                              lineHeight={{ base: '1.5rem', md: '1.688rem' }}
                              color=" #6D6358"
                              noOfLines={3}
                              str={render(item.testimonialText)}
                              fontStyle="italic"
                            />
                          ) : (
                            <Box
                              fontSize={{ base: '1rem', md: '1.125rem' }}
                              lineHeight={{ base: '1.5rem', md: '1.688rem' }}
                              color=" #6D6358"
                              noOfLines={3}
                              fontStyle="italic"
                            >
                              {renderText}
                            </Box>
                          )}
                          <Box
                            as="span"
                            fontSize="1rem"
                            lineHeight={{ base: '1.5rem', md: '1.688rem' }}
                            color="#CE6113"
                            display="block"
                            onClick={() => {
                              onOpen();
                              setModalData(item);
                            }}
                            _hover={{
                              color: '#CE6113',
                              textDecoration: 'underline',
                            }}
                            cursor="pointer"
                            backgroundColor="#fff"
                            position={!isMobile && 'absolute'}
                            bottom="0%"
                            right="0%"
                          >
                            {/* Read More */}
                            {item?.testimonialTitle?.value?.document
                              ?.children?.[0]?.children?.[1]?.children?.[0]
                              ?.value ||
                              item?.testimonialTitle?.value?.document
                                ?.children?.[0]?.children?.[2]?.children?.[0]
                                ?.value}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Slider>
        </Box>
      </Flex>
      {modalData !== null &&
        isOpen &&
        (isMobile ? (
          <RemarketMobileDrawer
            header={true}
            imgWidth="200px"
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ) : (
          <RemarketStorieModal
            lang={lang}
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ))}
    </Box>
  );
};

export default RemarketStories;
